import script from "./BaseChecklist.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseChecklist.vue?vue&type=script&setup=true&lang=ts"

import "./BaseChecklist.vue?vue&type=style&index=0&id=2c86e8f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c86e8f0"]])

export default __exports__